// extracted by mini-css-extract-plugin
module.exports = {"resetButtonContainer":"Invitation-tab_resetButtonContainer_1wFKn"};